/**
 * Contact form with multiple pages
 */

var component_multipage_form = function(args) {

  // setup args
  var container = args.form_container
  var form = container.querySelector('.gform_wrapper');

  // validate
  if (!form) {
    console.log('Invalid form (multipage form)');
    return;
  }

  function checkBoxesAndRadios() {
    // add class to checkbox labels
    form.querySelectorAll('.ginput_container_checkbox').forEach(checkbox => {
      checkbox.previousSibling.classList.add('checkboxes-label');
    });

    // add class to radio button labels
    form.querySelectorAll('.ginput_container_radio').forEach(radio => {
      radio.previousSibling.classList.add('radio-buttons-label');
    });
  }

  // show progess e.g. PAGE 1 / 2
  function pagination(currentPage) {
    let total = form.querySelectorAll('.gform_page').length;
    let formFooters = form.querySelectorAll('.gform_page_footer');
    let screenReaderText = document.createElement('div');
    screenReaderText.classList.add('screen-reader-text');
    screenReaderText.setAttribute('aria-live', 'polite');

    // if pagination doesn't exist or the page has changed

    formFooters.forEach((footer) => {
      let pagination = footer.querySelector('.multipage-form__pagination');

      if (!pagination) {
        pagination = document.createElement('span');
        pagination.innerHTML = `${theme_strings.page} ${currentPage} / ${total}`;
        // add class
        pagination.classList.add('multipage-form__pagination');
        // set current page to data-attribute
        pagination.dataset.currentPage = currentPage;
        footer.appendChild(pagination);
        // screen reader
        screenReaderText.innerHTML = `<span>${theme_strings.page} ${currentPage} / ${total}</span>`;
        form.appendChild(screenReaderText);
      } else if (pagination.dataset.currentPage !== currentPage) {
        pagination.innerHTML = `${theme_strings.page} ${currentPage} / ${total}`;
        // set current page to data-attribute
        pagination.dataset.currentPage = currentPage;
        // screen reader
        screenReaderText.innerHTML = `<span>${theme_strings.page} ${currentPage} / ${total}</span>`;
      }
    })

  }

  /**
   * Init
   */
  function init() {

    // on page load (multipage form)
    jQuery(document).on('gform_post_render', (event, form_id, current_page) => {
      checkBoxesAndRadios();
      pagination(current_page);
    });
  }

  init();

  // make the call chainable
  return this;

};

